import { CIcon } from '~/icons/types'
export const ciHistory: CIcon = {
  width: 16,
  height: 14,
  paths: [
    {
      d:
        'M3.704 7.236v.041l.579-.577a.87.87 0 0 1 1.23-.004.865.865 0 0 1 .004 1.223L3.534 9.907a.874.874 0 0 1-1.214.02L.297 8.157A.863.863 0 0 1 .83 6.695a.873.873 0 0 1 .612.169l.52.458a7.005 7.005 0 0 1 1.042-4.014A6.833 6.833 0 0 1 6.13.623 7.866 7.866 0 0 1 7.563.168a6.88 6.88 0 0 1 4.65.595 6.823 6.823 0 0 1 3.175 3.431c.198.459.35.936.452 1.425a6.758 6.758 0 0 1-.17 3.49 6.88 6.88 0 0 1-1.894 2.933 7.447 7.447 0 0 1-2.938 1.697 6.353 6.353 0 0 1-5.274-.763.865.865 0 0 1 .292-1.572.874.874 0 0 1 .654.12 4.482 4.482 0 0 0 1.462.63 4.64 4.64 0 0 0 2.374-.07 5.707 5.707 0 0 0 2.25-1.312 5.136 5.136 0 0 0 1.424-2.209c.27-.84.316-1.737.13-2.6a5.978 5.978 0 0 0-.35-1.1 5.085 5.085 0 0 0-2.375-2.571 5.128 5.128 0 0 0-3.484-.436c-.38.08-.752.198-1.109.352a5.07 5.07 0 0 0-2.34 2 5.278 5.278 0 0 0-.788 3.028Zm4.217-2.833c0-.21.083-.411.233-.56a.798.798 0 0 1 1.358.56v2.46l1.938 1.07a.79.79 0 0 1 .308 1.075.793.793 0 0 1-1.08.306l-2.29-1.265a.794.794 0 0 1-.468-.721V4.403Z',
      fill: 'currentColor'
    }
  ],
  name: 'history',
  type: 'regular'
}
